import { render, staticRenderFns } from "./CreatePasswordPage.vue?vue&type=template&id=65cc9774&scoped=true"
import script from "./CreatePasswordPage.vue?vue&type=script&lang=js"
export * from "./CreatePasswordPage.vue?vue&type=script&lang=js"
import style0 from "./CreatePasswordPage.vue?vue&type=style&index=0&id=65cc9774&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cc9774",
  null
  
)

export default component.exports